import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface UseNegotiatorSrtTokensProps {
  from?: string | null;
  to?: string | null;
  billingAccountId?: string;
}

export const useNegotiatorSrtTokens = ({
  from,
  to,
  billingAccountId
}: UseNegotiatorSrtTokensProps) => {
  const queryParams = new URLSearchParams();
  if (from) queryParams.append('from', from);
  if (to) queryParams.append('to', to);
  if (billingAccountId) queryParams.append('billingAccountId', billingAccountId);

  const queryString = queryParams.toString();

  return useQuery({
    queryKey: ['srt-negotiator', from, to, billingAccountId],
    queryFn: async () => {
      const response = await fetchAPI<{ message: string; data: NegotiatorUsageBreakdown }>({
        method: 'GET',
        route: 'srt/negotiator',
        queryString
      });
      return response;
    },
    enabled: !!from && !!to,
    // Analytics chart — see useAISrtTokens for rationale.
    staleTime: 10 * 60 * 1000
  });
};

export default useNegotiatorSrtTokens;
